export const SEARCH_FORCE_REFRESH = 'search/SEARCH_FORCE_REFRESH';
export const GET_PATIENT_RESULTS = 'search/GET_PATIENT_RESULTS';
export const PATIENT_SEARCH_FIELDS = 'search/@PATIENT_SEARCH_FIELDS';
export const CLEAR_SEARCH_RESULTS = 'search/CLEAR_SEARCH_RESULTS';

export const GET_INFINITE_SCROLL_PATIENT_RESULT =
  'search/GET_INFINITE_SCROLL_PATIENT_RESULTS';
export const PAGE_INFINITE_SCROLL_PATIENT_RESULT =
  'search/PAGE_INFINITE_SCROLL_PATIENT_RESULT';
export const UPDATE_SEARCH_CURRENT_PAGE = 'search/UPDATE_CURRENT_PAGE';
export const UPDATE_SEARCH_CURRENT_SORT = 'search/UPDATE_CURRENT_SORT';



// WEBPACK FOOTER //
// ./src/state/reducers/search/types.js